export default __webpack_public_path__ + "static/hand-1809c7c268a91729956386144c9972b4.webp";